import type { AdhocSession, AdhocSessionRequest, AdhocSessionResponse } from '@/models/AdhocSession.model'
import type { RequestFn } from '@/composables/useApi'
import { useApi } from '@/composables/useApi'
import { NoAdhocSessionFound, UnknownError } from '@/services/Exceptions'

const getAdhocSessions = (get: RequestFn) => async (request: AdhocSessionRequest): Promise<Array<AdhocSession>> => {
  let sessionResponse = null
  try {
    sessionResponse = await get<AdhocSessionResponse>('/adhoc/sessions', {
      query: request,
    })
  }
  catch (error) {
    throw new UnknownError(error.message)
  }

  if (!sessionResponse) {
    throw new UnknownError()
  }

  if (sessionResponse.success === false) {
    throw new UnknownError(sessionResponse.error)
  }

  if (sessionResponse.data === null) {
    throw new UnknownError('Response success was true but data is missing')
  }

  if (sessionResponse.data.length === 0) {
    throw new NoAdhocSessionFound()
  }

  return sessionResponse.data
}

export const useAdhocSessionService = () => {
  const { get } = useApi()

  return {
    getAdhocSessions: getAdhocSessions(get),
  }
}
